import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Ticket, WifiOff } from "lucide-react";
import { savedTickets } from "../../lib/pwa";

/** Sin internet: accesos a los pasajes guardados en este celular. */
export const OfflineTickets = () => {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && !navigator.onLine);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);
  if (!offline) return null;
  const list = Object.entries(savedTickets());
  return (
    <div data-testid="offline-tickets" className="fixed inset-x-3 bottom-3 z-50 rounded-3xl bg-[var(--ink)] p-4 text-white shadow-2xl md:inset-x-auto md:right-6 md:w-96">
      <p className="flex items-center gap-2 text-sm font-bold"><WifiOff className="h-4 w-4 text-[var(--lime)]" /> Estás sin conexión</p>
      {list.length ? (
        <div className="mt-3 space-y-2">
          <p className="text-xs text-white/80">Tus pasajes guardados en este celular:</p>
          {list.map(([path, { b }]) => (
            <Link key={path} to={`/mi-pasaje/${path}`} data-testid={`offline-ticket-${b?.code}`} className="flex items-center gap-3 rounded-2xl bg-white/10 p-3 text-sm hover:bg-white/15">
              <Ticket className="h-4 w-4 shrink-0 text-[var(--lime)]" />
              <span><b>{b?.origin} → {b?.destination}</b><br /><span className="text-xs text-white/80">{b?.date} · {b?.departure} hs · {b?.code}</span></span>
            </Link>
          ))}
        </div>
      ) : <p className="mt-2 text-xs text-white/80">Cuando abras tu pasaje con internet, queda guardado para verlo sin conexión.</p>}
    </div>
  );
};
